import { slice, take } from 'lodash'
import Grid from 'material-ui/Grid'
import Fade from 'material-ui/transitions/Fade'
import Typography from 'material-ui/Typography'
import * as React from 'react'
import { SFC } from 'react'
import { BigGreenButton } from '../components/BigGreenButton'
import { Divider } from '../components/Divider'
import { SpreadBody } from '../components/SpreadBody'

interface Service {
    title: string
    icon: string
    description: string
    things: string[]
}

interface State {
    showAdditional: boolean
}

export class ServicesSpread extends React.Component<{}, State> {

    state: State = {
        showAdditional: false
    }

    services: Service[] = [
        {
            title: 'STRATEGY & PLANNING',
            icon: '/img/service-icons/discovery.svg',
            description: 'Got an idea? We’ll help you discover its potential and plan for its success.',
            things: [
                'Research',
                'Competitive Analysis',
                'Analytics',
                'Feature Definition',
                'Story Mapping',
                'User Personas',
                'Content Strategy',
                'Release Roadmapping'
            ],
        },
        {
            title: 'UI/UX DESIGN',
            icon: '/img/service-icons/ui.svg',
            description: 'In today’s crowded digital spaces, functional, ' +
            'usable, and pleasurable design matters. Let us help.',
            things: [
                'Wireframes',
                'User Workflows',
                'Information Architecture',
                'Prototyping',
                'Visual Design',
                'UI Toolkits',
                'Art Direction',
                'Component Libraries',
            ],
        },
        {
            title: 'APP & WEB DEVELOPMENT',
            icon: '/img/service-icons/app.svg',
            description: 'From Mobile to Web, front-end to APIs, Dev to DevOps, we architect highly-complex platforms ',
            things: [
                'iOS & Android',
                'Mobile: Native & Ionic',
                'React.js & AngularJS',
                'PostgreSQL & MySQL',
                'Cassandra & MongoDB',
                'Java/Kotlin & Spring',
                'Python & Django',
                'AWS, Ansible, & Docker'
            ],
        },
        {
            title: 'DATA & MACHINE LEARNING',
            icon: '/img/service-icons/ml.svg',
            description: 'Know when to use AI? Which model to use? ' +
            'How to scale a model into production? Look no further.',
            things: [
                'Deep Neural Nets',
                'Logistic Regression',
                'Natural Language',
                'Processing (NLP)',
                'Random Forest',
                'Scikit-learn & Pandas',
                'AI into Production',
                'Analytics & Visualization'
            ],
        }
    ]

    otherServices =
        [
            {
                title: 'Software Architecture',
                description: 'We build ecosystems that choreograph Apps, servers, data, and processes.'
            },
            {
                title: 'Mobile App Development',
                description: 'native android, ionic'
            },
            {
                title: 'DevOps',
                description: 'ci, ansible, docker, kubernetes, vpc, multi-az, automation, datadog, logentries'
            },
            {
                title: 'API Design & Development',
                description: 'api...'
            },
            {
                title: 'Front-End Web Development',
                description: 'react/angular.'
            },
            {
                title: 'Managed Cloud Hosting',
                description: 'kubernetes, multi-data-center'
            },
            {
                title: 'SBIR & Grant Partnerships',
                description: 'We\'ve worked with many organizations on NIH, NSF, and US Dept of Ed grants.'
            },
            {
                title: 'Software/Server Development',
                description: 'Java, springboot, python, testing[]'
            },
            {
                title: 'Amazon Web Services (AWS)',
                description: 'cloudformation, vpc, ci, '
            }
        ]

    ServiceCardItem: SFC<{ title: string }> = ({title}) => {
        return (<Typography type='caption' style={{lineHeight: 2}} component='li'>{title}</Typography>)
    }

    ServiceCard: SFC<{ serviceInfo: Service, index: number }> =
        ({serviceInfo: {title, icon, description, things}, index}) => {
            const {ServiceCardItem} = this

            // const borderWidth = '0 1px 0 0'
            let borderWidth: string
            switch (index) {
                case 0:
                    borderWidth = '0 1px 1px 0'
                    break
                case 1:
                    borderWidth = '0 0 1px 1px'
                    break
                case 2:
                    borderWidth = '1px 1px 0 0'
                    break
                case 3:
                    borderWidth = '1px 0 0 1px'
                    break
                default:
                    borderWidth = '0'
            }

            const halfPoint = Math.ceil(things.length / 2)
            const leftSide = take(things, halfPoint)
            const rightSide = slice(things, halfPoint)

            return (
                <div
                    style={{
                        padding: 40,
                        borderColor: '#eee',
                        borderStyle: 'solid',
                        borderWidth,
                    }}
                >
                    <img src={icon} alt={title} style={{height: 60}}/>
                    <Typography type='title' style={{margin: '20px 0'}}>{title}</Typography>
                    <Typography type='subheading' style={{margin: '20px 0'}}>{description}</Typography>
                    <div style={{margin: 0}}>
                        <Grid container spacing={8}>
                            <Grid item xs={6}>
                                <ul style={{margin: 0, padding: 0}}>
                                    {leftSide.map((t, i) => <ServiceCardItem key={i} title={t}/>)}
                                </ul>
                            </Grid>
                            <Grid item xs={6}>
                                <ul style={{margin: 0, padding: 0}}>
                                    {rightSide.map((t, i) => <ServiceCardItem key={i} title={t}/>)}
                                </ul>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )
        }

    AdditionalService: SFC<{ title: string }> = ({title, children}) => (
        <Grid item xs={12} sm={6} md={4}>
            <Typography type='title' style={{fontSize: 16, lineHeight: 2}}>{title}</Typography>
            <Typography type='body1' style={{fontSize: 16, lineHeight: 2}}>{children}</Typography>
        </Grid>
    )

    AdditionalServices = () => {
        const {AdditionalService} = this
        return (
            <div style={{textAlign: 'left'}}>
                <Typography type='display1' style={{margin: '20px 0', fontWeight: 600}}>We also do...</Typography>
                <Grid container>
                    {
                        this.otherServices.map((s, i) => {
                            return (
                                <Fade key={i} in={this.state.showAdditional} timeout={(i + 1) * 150}>
                                    <AdditionalService title={s.title}>
                                        {s.description}
                                    </AdditionalService>
                                </Fade>
                            )
                        })
                    }
                </Grid>
            </div>
        )
    }

    toggleAdditionalServices = () => this.setState({showAdditional: !this.state.showAdditional})

    ToggleAllServicesButton = () => (
        <BigGreenButton
            text={this.state.showAdditional ? 'Hide services' : 'See all our services'}
            onClick={this.toggleAdditionalServices}
        />
    )

    render() {
        const {ServiceCard} = this
        return (
            <SpreadBody>
                <div style={{maxWidth: 590, margin: 'auto'}}>
                    <Divider/>
                    <Typography type='display1' style={{margin: '20px 0'}}>
                        We shape ideas into elegant solutions using technology and design.
                    </Typography>
                    <Typography type='subheading' style={{margin: '8px auto ', lineHeight: 2}}>
                        Beautiful websites, elegant Apps, scalable APIs.
                        We take our decades of expertise across the most popular open-source technologies
                        to forge solutions.
                    </Typography>
                </div>
                <div style={{textAlign: 'left', margin: 'auto', padding: '50px 0 0'}}>
                    <Grid container spacing={0}>
                        {this.services.map((s, i) => (
                            <Grid key={i} item xs={12} md={6}>
                                <ServiceCard serviceInfo={s} index={i}/>
                            </Grid>
                        ))}
                    </Grid>
                </div>
                {/*{this.state.showAdditional && <AdditionalServices/>}*/}
                {/*<ToggleAllServicesButton/>*/}
            </SpreadBody>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/index/ServicesSpread.tsx